import { render } from "./PromoBanner.vue?vue&type=template&id=36b21737&scoped=true"
import script from "./PromoBanner.vue?vue&type=script&lang=js"
export * from "./PromoBanner.vue?vue&type=script&lang=js"

import "./PromoBanner.vue?vue&type=style&index=0&id=36b21737&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b21737"]])

export default __exports__